<template>
  <v-card>
    <v-card-title class="headline">Add presentation</v-card-title>

    <v-form v-model="valid" ref="form" @submit.prevent="createPresentation">
      <v-card-text>
        <v-text-field
            filled
            validate-on-blur
            v-model="title"
            :rules="titleRules"
            :messages="fireBaseValidationMessages"
            label="Presentation title"
            type="text"
        ></v-text-field>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="closeModal">
          Cancel
        </v-btn>
        <v-btn class="primary" type="submit" dark>
          Next
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'add-presentation-modal',

  data() {
    return {
      state: 'loading',
      valid: true,
      fireBaseValidationMessages: [],
      title: '',
      titleRules: [
        v => !!v || 'Title is required'
      ]
    };
  },

  computed: mapGetters([
    'userId',
    'isAnonymous',
    'draftPresentation',
    'currentDraft'
  ]),

  watch: {
    currentDraft(val) {
      if (val) {
        this.$router.push({
          name: 'view-presentation',
          params: {
            presentationId: val.presentationId
          }
        });
      }
    }
  },

  methods: {
    createPresentation() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch('createOrUpdatePresentation', {
          title: this.title
        })
          .then(() => {
            this.$emit('addPresentationModalClosed');
          })
          .catch((err) => {
            console.log('Error when creating presentation: ', err);
          });
      }
    },

    closeModal() {
      this.$emit('addPresentationModalClosed');
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AddPresentationModal.vue